import { FC } from "react";
import styled from "styled-components";
import PlayControls from "../components/PlayControls";
import FramesGrid from "../components/FramesGrid";

const BottomBarContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 8px;
    flex-shrink: 0; /* Don't let the bottom bar shrink */
`;

type FRAMES_TYPE = 'row' | 'grid';
const FRAMES: FRAMES_TYPE = 'grid' as FRAMES_TYPE;

interface BottomBarProps {
    orderedImages: string[];
    currentFrameIndex: number;
    numOfFrames: number;
    startFrame: number;
    endFrame: number;
    handleRangeChange: (start: number, end: number) => void;
    handleReorder: (newOrder: string[]) => void;
    onFrameClick: (index: number) => void;
    setIsPlaying: (isPlaying: boolean) => void;
    handleFrameChange: (frame: number) => void;
    isPlaying: boolean;
    handlePlayPauseClick: () => void;
    isPlaceholder: boolean;
    isMobile: boolean;
    hiddenFrames: number[];
}

const BottomBar: FC<BottomBarProps> = ({ 
    orderedImages, 
    currentFrameIndex, 
    numOfFrames, 
    startFrame,
    endFrame,
    handleRangeChange,
    handleReorder, 
    onFrameClick, 
    setIsPlaying,
    handleFrameChange,
    isPlaying,
    handlePlayPauseClick,
    isPlaceholder,
    isMobile,
    hiddenFrames,
}) => {
    return (
        <BottomBarContainer>
            <PlayControls
                currentFrame={currentFrameIndex}
                numFrames={numOfFrames}
                startFrame={startFrame}
                endFrame={endFrame}
                handleFrameChange={handleFrameChange}
                handleRangeChange={handleRangeChange}
                isPlaying={isPlaying}
                handlePlayPauseClick={handlePlayPauseClick}
                isPlaceholder={isPlaceholder}
                isMobile={isMobile}
            />
            <FramesGrid
                orderedImages={orderedImages}
                currentFrameIndex={currentFrameIndex}
                numOfFrames={numOfFrames}
                startFrame={startFrame}
                endFrame={endFrame}
                handleReorder={handleReorder}
                onFrameClick={onFrameClick}
                setIsPlaying={setIsPlaying}
                isMobile={isMobile}
                hiddenFrames={hiddenFrames}
            />
        </BottomBarContainer>
    );
};

export default BottomBar;